"use strict";
import React, { useLayoutEffect, useState } from "react";
let nextOrder = 0;
let mountedEntries = [];
function applyTitle() {
  const innermost = mountedEntries.reduce(
    (best, entry) => !best || entry.order > best.order ? entry : best,
    void 0
  );
  const title = innermost ? innermost.title : "";
  if (document.title !== title) {
    document.title = title;
  }
}
export default function DocumentTitle({
  title,
  children
}) {
  const [entry] = useState(() => ({ order: nextOrder++, title }));
  useLayoutEffect(() => {
    mountedEntries.push(entry);
    return () => {
      mountedEntries = mountedEntries.filter((e) => e !== entry);
      applyTitle();
    };
  }, [entry]);
  useLayoutEffect(() => {
    entry.title = title;
    applyTitle();
  }, [entry, title]);
  return children ? React.Children.only(children) : null;
}
